import { atom, PrimitiveAtom } from 'jotai';

import { Remote } from 'utils/remote';

export type DataAtom<T> = PrimitiveAtom<Remote<T>>;

/**
 * Payload: e.g. { idToken: string | null }
 * @param initialPayload - e.g. { idToken: '1234', fetchStatus: 'SUCCESS' }
 * @returns an atom containing the payload with fetchStatus and errorMessage attributes.
 */
export function getDataAtom<Payload>(
  initial: Remote<Payload> = { fetchStatus: 'INITIAL' },
) {
  return atom<Remote<Payload>>(initial);
}
